// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

// Your Firebase config object
const firebaseConfig = {
  apiKey: "AIzaSyAKVVHwrj_nydYdyAnrIw3a_47Ehw2YlEY",
  authDomain: "lotto-6e3ee.firebaseapp.com",
  projectId: "lotto-6e3ee",
  storageBucket: "lotto-6e3ee.appspot.com",
  messagingSenderId: "319470651352",
  appId: "1:319470651352:web:686c5b9f18082300ddd4ad",
  databaseURL: "https://lotto-6e3ee-default-rtdb.firebaseio.com"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export initialized services
export const auth = getAuth(app);         // Firebase Auth
export const db = getFirestore(app);      // Firestore
export const database = getDatabase(app); // Realtime DB
